/**
 * Portal Manta · FonteModal
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';

function FonteModal({fonte, label, onClose}){
  if(!fonte) return null;
  return (<div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(30,42,74,.55)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
    <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:'18px 22px',minWidth:380,maxWidth:520,boxShadow:'0 10px 40px rgba(0,0,0,.25)'}}>
      <div style={{fontSize:10,fontWeight:700,color:V.or,letterSpacing:.5,textTransform:'uppercase',marginBottom:4}}>📍 Rastreabilidade</div>
      <div style={{fontSize:14,fontWeight:700,color:V.br,marginBottom:14}}>{label}</div>
      <table style={{width:'100%',fontSize:11.5}}>
        <tbody>
          <tr><td style={{padding:'4px 0',color:V.g4,width:90}}>Documento</td><td style={{padding:'4px 0',color:V.g7,fontWeight:600}}>{fonte.doc}</td></tr>
          <tr><td style={{padding:'4px 0',color:V.g4}}>Página/Aba</td><td style={{padding:'4px 0',color:V.g7}}>{fonte.pag}</td></tr>
          <tr><td style={{padding:'4px 0',color:V.g4}}>Data-base</td><td style={{padding:'4px 0',color:V.g7}}>{fonte.data}</td></tr>
          <tr><td style={{padding:'4px 0',color:V.g4}}>Responsável</td><td style={{padding:'4px 0',color:V.g7}}>{fonte.aut}</td></tr>
        </tbody>
      </table>
      <div style={{marginTop:14,paddingTop:10,borderTop:'1px solid '+V.g2,fontSize:10,color:V.g4}}>
        Versão portal v20 · Manta Associados · classificação: confidencial
      </div>
      <button onClick={onClose} style={{marginTop:12,padding:'7px 14px',fontSize:11,fontWeight:600,background:V.or,color:'#fff',border:'none',borderRadius:6,cursor:'pointer'}}>Fechar</button>
    </div>
  </div>);
}

export { FonteModal };
export default FonteModal;
